import { z } from 'zod';

export const InstanceFormSchema = z.object({
  duration: z.number().min(1, 'Duration is required'),
  instanceCount: z.string().min(1, 'Instance count is required'),
  configs: z.array(z.string()).min(1, 'Config is required'),
});
